// @flow

import React, { Component } from "react";
import classNames from "classnames";

import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";
import { DatePicker } from "@components";
import type { DateTimeWidget as DateTimeWidgetProps } from "react-jsonschema-form/lib/components/widgets/SelectWidget";

type Props = $Exact<{
  ...DateTimeWidgetProps,
  options: Object,
}>;

export class DatePickerWidget extends Component<Props> {
  handleChange = (value: string) => {
    this.props.onChange(value === "" ? undefined : value);
  };

  render() {
    const props = Object.assign({}, this.props, {
      onChange: this.handleChange,
      value: this.props.value,
      ...this.props.options,
    });

    return (
      <div>
        <DatePicker {...props} className={classNames("DatePicker", this.props.className)} />
        <PostWidgetChatBubble options={this.props.options} />
        <PostWidgetInfoSection options={this.props.options} />
      </div>
    );
  }
}

export default DatePickerWidget;
